import _ from 'lodash-es';

import request from "../../../libs/request";

export default class DataTileCore {

    constructor(props) {
        this.props = props;
        this.data = [];
        this.value = null;
    }

    async loadData() {
        if (_.get(this.props, "dataSrc") === 'url') {
            if (_.get(this.props, "data.url", "").length > 0) {
                var response = await request.get(this.props.data.url);
                this.data = _.get(response, "data", []);
            }
        } else if (_.get(this.props, "dataSrc") === 'values') {
            this.data = _.get(this.props, "values", []);
        }
    }

    getData() {
        return this.data;
    }

    getRef(data) {
        if (this.props.valueProperty) {
            return 'tile-' + data[this.props.valueProperty];
        }
        return 'tile-' + data["value"];
    }

    setSelected(data) {
        document.querySelectorAll(`#${this.props.id} .data-tile`).forEach(el => el.classList.remove('selected'));
        document.querySelector(`#${this.props.id} .data-tile[ref=${this.getRef(data)}]`).classList.add('selected');
    }

    renderItem(data) {
        var html = "";
        if (_.get(this.props, "dataSrc") === 'url') {
            html = _.get(this.props, "template", "").replace(/{{(.+?)}}/g, (g0, g1) => {
                return _.get(data, _.trim(g1)) || g1;
            });
        } else if (_.get(this.props, "dataSrc") === 'values') {
            html = "<p><strong>" + _.get(data, "item.label") + "</strong></p>";
        }
        return html;
    }

    renderTiles() {
        var html = "";
        for (var i in this.data) {
            var dataObj = {
                item: this.data[i]
            };
            var selected = (this.data[i][this.props.valueProperty] === this.value) ? " selected" : "";
            html +=
                "<div class='col-md-3'>" +
                    "<div class='data-tile vertical-align" + selected + "' ref='" + this.getRef(this.data[i]) + "'>" +
                        this.renderItem(dataObj) +
                    "</div>" +
                "</div>";
        }
        return html;
    }

    render(children) {
        const html = "<div class='data-tile-component' " + 
            (this.props.id ? "id='" + this.props.id + "'" : "") +
            ">" +
                "<div class=\"row\">" +
                    this.renderTiles() +
                "</div>" +
            "</div>";
        return html;
    }
}
